import axiosIns from '@/libs/axios'

const ROOT_URL = '/edges/rescan-jobs'

export default {
  namespaced: true,
  state: {
    jobs: [],
    loading: false,
    cancellingId: null,
    notice: { status: null, message: null },
  },
  getters: {
    jobs: state => state.jobs,
    loading: state => state.loading,
    cancellingId: state => state.cancellingId,
    notice: state => state.notice,
  },
  mutations: {
    SET_JOBS(state, jobs) { state.jobs = jobs || [] },
    SET_LOADING(state, value) { state.loading = value },
    SET_CANCELLING_ID(state, value) { state.cancellingId = value },
    SET_NOTICE(state, value) { state.notice = value },
  },
  actions: {
    fetch({ commit }, { limit = 100, silent = false } = {}) {
      if (!silent) commit('SET_LOADING', true)
      return axiosIns.get(ROOT_URL, { params: { limit } })
        .then(response => {
          const jobs = response.data.data || []
          commit('SET_JOBS', jobs)
          return jobs
        })
        .catch(error => {
          const message = error?.response?.data?.message || 'Rescan job listesi alınamadı.'
          commit('SET_NOTICE', { status: false, message })
          throw error
        })
        .finally(() => {
          if (!silent) commit('SET_LOADING', false)
        })
    },
    cancel({ commit, dispatch }, id) {
      commit('SET_CANCELLING_ID', id)
      return axiosIns.post(`${ROOT_URL}/${id}/cancel`)
        .then(response => {
          const status = response.data.data?.status
          commit('SET_NOTICE', {
            status: true,
            message: status === 'CANCEL_REQUESTED'
              ? 'Çalışan rescan için iptal istendi.'
              : 'Rescan iptal edildi.',
          })
          return dispatch('fetch', { silent: true })
        })
        .catch(error => {
          const message = error?.response?.data?.message || 'Rescan iptal edilemedi.'
          commit('SET_NOTICE', { status: false, message })
          throw error
        })
        .finally(() => commit('SET_CANCELLING_ID', null))
    },
  },
}
